import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: []
};
export var AlgorithmsReducer = createSlice({
    name: 'algorithms',
    initialState: initialState,
    reducers: {
        init: function init(state, reports) {
            state.data = reports.payload;
        },
        add: function add(state, report) {
            var algorithm = {
                name: report.payload.name || ''
            };
            state.data.push(algorithm);
        }
    }
});
var _AlgorithmsReducer$ac = AlgorithmsReducer.actions, add = _AlgorithmsReducer$ac.add, init = _AlgorithmsReducer$ac.init;
export { add, init };
export default AlgorithmsReducer.reducer;
